import HTTP from '@/scripts/http'
import jsencrypt from 'jsencrypt'
import _ from 'lodash'
const http = new HTTP()

// 创建一个带key记录的throttle包装方法，wait时间到了再删除key
function createKeyedThrottle () {
  const throttleMap = new Map()

  return function (key, func, wait, options = {}) {
    if (!throttleMap.has(key)) {
      const throttledFunc = _.throttle(func, wait, options)
      throttleMap.set(key, throttledFunc)

      // 设置定时器，在wait时间后删除key
      setTimeout(() => {
        throttleMap.delete(key)
      }, wait)
    }
    return throttleMap.get(key)
  }
}
const keyedThrottle = createKeyedThrottle()

const state = {
  outpatientRecord: {},
  triageToken: '',
  triageConfig: {
    rsaPubKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsqhcE4HaqdEOVSMUPbvFxQMN0HvYezgFbnEMzXBcgQ7dBzXp1GV5ZWEELzbIrQsBCwxLygzArparzF2HT8RxRiSCJIvQUBX/eBeucfozZJ1HW8uE/AC1N9O2A8Zdu1VXDgHVKgJ8Rtgoq2+k6AP9XQo2h7vYtlKezCX6Yso9zbYRpArmhuUt0fhxDkbbVYThOX+49tadm+n6rTpt3094ND9p1d76mB+35WIlCbYtm22QCrGG75VgPFNCZ6emjM3hWS2mXSXBi7+rr/WsPhRv3WBCnJlUHa4ldFZJed8vNOPxLUCehWg50XGW0QqqVpf/RX1weJcv+IDK6JdYOGAYFQIDAQAB',
    password: '123456',
    hospitalId: '5',
    appid: '1011'
  }
}

const mutations = {
  setOutpatientRecord (state, outpatientRecord) {
    _.merge(state.outpatientRecord, outpatientRecord)
  },
  clearOutpatientRecord (state) {
    state.outpatientRecord = {}
  },
  SET_TRIAGE_TOKEN (state, token) {
    state.triageToken = `bearer ${token}`
  }
}

const actions = {
  fetchOutpatientRecord ({ commit }) {
    // 这里可以添加异步获取门诊患者列表逻辑
    // commit('setPatients', data)
  },
  addOutpatientRecord ({ commit }, outpatientRecord) {
    commit('addOutpatientRecord', outpatientRecord)
  },
  clearOutpatientRecord ({ commit }) {
    commit('clearOutpatientRecord')
  },
  TriageLogin ({ commit, state }) {
    return new Promise(async (resolve, reject) => {
      try {
        let rsaPubKey = state.triageConfig.rsaPubKey
        let encrypt = new jsencrypt.JSEncrypt()
        encrypt.setPublicKey(rsaPubKey)
        let json = {
          'account': window.sessionStorage.getItem('user_code'),
          'password': state.triageConfig.password
        }
        let params = {
          login_info: encrypt.encrypt(JSON.stringify(json)),
          device_type_enum: 'OTHER_PC',
          login_from_enum: 'PC',
          client_application_enum: 'MANAGE_WEB',
          hospital_id: state.triageConfig.hospitalId
        }

        let response = await http.post('/open-api/webapi/third-party/user/login', params)

        if (response.err) {
          reject(response)
        } else {
          commit('SET_TRIAGE_TOKEN', response.access_token)
          resolve(response)
        }
      } catch (e) {
        reject(e)
      }
    })
  },
  TriageGetQueue ({ state }, params) {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await http.get('/open-api/webapi/third-party/get-queue', {
          ...params,
          hospital_id: state.triageConfig.hospitalId,
          appid: state.triageConfig.appid
        }, 'none', {
          Authorization: state.triageToken
        })

        if (response.err) {
          reject(response)
        } else {
          resolve(response)
        }
      } catch (e) {
        if (e.data.code === 'TriageApiParameter.400.08') { resolve({ queue: [] }) }
        reject(e)
      }
    })
  },

  GetOutpatientRecord (context) {
    const key = `GetOutpatientRecord_${window.sessionStorage.getItem('docOutpatientRecordId')}`

    const throttledFunc = keyedThrottle(key, async ({ commit }) => {
      try {
        let response = await http.get('/doctor-api/webapi/outpatient-record/get-outpatient-record', {
          outpatient_record_id: window.sessionStorage.getItem('docOutpatientRecordId')
        })

        if (response.err) {
          throw response
        } else {
          const { outpatientRecord } = response
          let treatmentType = outpatientRecord.treatment_type || '初诊'
          commit('clearOutpatientRecord')
          commit('setOutpatientRecord', { ...response, treatmentType })
          return response
        }
      } catch (e) {
        throw e
      }
    }, 5000, { leading: true, trailing: false })

    return throttledFunc(context)
  },

  /**
   * 检查诊断与就诊类型是否匹配
   * @param {Object} context - Vuex context
   * @param {Object} params - 参数对象
   * @param {Array} params.icd10Codes - ICD10诊断编码数组
   * @param {String} params.medType - 就诊类型代码
   * @param {Object} params.vueInstance - Vue实例，用于调用$Modal
   * @returns {Promise<Boolean>} - 返回是否验证通过
   */
  async checkDiagnosisTreatmentMatch (context, { icd10Codes, medType, vueInstance }) {
    try {
      if (['', '11'].includes(medType) || !icd10Codes || !icd10Codes.length) {
        return true
      }

      const diagnosis = await vueInstance.$http.reqDBResource(vueInstance.requestApi.DBApi.outpatientRecord.checkDiagnosis, {
        diagnosis: icd10Codes,
        medType: medType
      })

      if (diagnosis && diagnosis.length) {
        const diagnosisInfoList = diagnosis.map(d => {
          return {
            diagnosisName: d.icd10_name || d.icd10_code,
            typeName: d.med_name
          }
        })

        const contentHtml = diagnosisInfoList.map(info =>
          `<p style="margin: 10px 0; font-size: 15px; line-height: 2;">
            诊断 <span style="color: #ff4d4f; font-weight: bold; font-size: 16px;">"${info.diagnosisName}"</span> 
            的特殊就诊类型只能选择 <span style="color: #ff4d4f; font-weight: bold; font-size: 16px;">"${info.typeName}"</span>
          </p>`
        ).join('')

        if (vueInstance && vueInstance.$Modal) {
          vueInstance.$Modal.warning({
            title: '就诊类型不匹配提示',
            content: `
              <div style="color: #333;">
                ${contentHtml}
                <p style="margin-top: 15px; padding-top: 16px; border-top: 1px solid #e8e8e8; color: #666; font-size: 16px;">
                  请调整诊断或就诊类型后再继续操作！
                </p>
              </div>
            `,
            width: 520
          })
        }

        return false
      }

      return true
    } catch (e) {
      console.error('检查诊断与就诊类型匹配失败:', e)
      return true
    }
  }
}

const getters = {
  outpatientRecord: state => state.outpatientRecord,
  triageToken: state => state.triageToken
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
